export default "__VITE_ASSET__Bhy61uuM__"